// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result-data_columnName__hZ3im {
  background: var(--mui-palette-grey-100);
}

.result-data_column__-R7Rv {
  display: flex;
  align-items: center;
  width: 50%;
  padding: 16px;
}

@media only screen and (max-width: 768px) {
  .result-data_column__-R7Rv {
    width: 100%;
    box-sizing: border-box;
  }
}

.result-data_rowWrapper__9CSlI {
  display: flex;
  border-bottom: 1px solid var(--mui-palette-grey-300);
  font-size: 12px;
}

@media only screen and (max-width: 768px) {
  .result-data_rowWrapper__9CSlI {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border-bottom: none;
  }
}

.result-data_tableWrapper__yoVfw {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
}

@media only screen and (max-width: 768px) {
  .result-data_tableWrapper__yoVfw {
    display: block;
  }
}

.result-data_alert__ptuGq {
  font-weight: 600;
  color: var(--mui-palette-error-dark);
}`, "",{"version":3,"sources":["webpack://./src/components/most/list/history/item/result-data/index.module.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC","sourcesContent":[".columnName {\n  background: var(--mui-palette-grey-100);\n}\n\n.column {\n  display: flex;\n  align-items: center;\n  width: 50%;\n  padding: 16px;\n}\n\n@media only screen and (max-width: 768px) {\n  .column {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n.rowWrapper {\n  display: flex;\n  border-bottom: 1px solid var(--mui-palette-grey-300);\n  font-size: 12px;\n}\n\n@media only screen and (max-width: 768px) {\n  .rowWrapper {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    border-bottom: none;\n  }\n}\n\n.tableWrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-flow: column;\n}\n\n@media only screen and (max-width: 768px) {\n  .tableWrapper {\n    display: block;\n  }\n}\n\n.alert {\n  font-weight: 600;\n  color: var(--mui-palette-error-dark);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"columnName": `result-data_columnName__hZ3im`,
	"column": `result-data_column__-R7Rv`,
	"rowWrapper": `result-data_rowWrapper__9CSlI`,
	"tableWrapper": `result-data_tableWrapper__yoVfw`,
	"alert": `result-data_alert__ptuGq`
};
export default ___CSS_LOADER_EXPORT___;
